import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { CONSTANTS } from '@pk/powerkioskutils';

export interface AuctionProduct {
	rfqSessionProductId?: FormControl<string>;
	type: FormControl<string>;
	term: FormControl<number>;
	greenPercentage: FormControl<number>;
	hidden?: FormControl<boolean>;
}

@Injectable({
	providedIn: 'root',
})
export class AuctionService {
	public getProductNote(stateId: string, products: FormArray<FormGroup<AuctionProduct>>): string {
		const productNotes: string[] = [];
		productNotes.push('"Energy Only"');

		if (products.value.some(p => p.type === CONSTANTS.products.fixedAllInElectric)) {
			switch (stateId) {
				case CONSTANTS.states.texas:
					productNotes.push('"Fixed w/ Basis Pass Through"');
					break;
				case CONSTANTS.states.connecticut:
				case CONSTANTS.states.maine:
				case CONSTANTS.states.massachusetts:
				case CONSTANTS.states.newHampshire:
				case CONSTANTS.states.rhodeIsland:
				case CONSTANTS.states.vermont:
					productNotes.push('"Fixed (DASI Adjusted)"', '"Fixed (DASI Included)"', '"Fixed (DASI Pass Through)"');
					break;
				default:
					productNotes.push('"Fixed w/ Adjustment"');
					break;
			}
		}

		return `${productNotes.join(', ')} product${productNotes.length > 1 ? 's' : ''} will be added automatically for each unique term + green percentage included in the new products getting added above if not already added.`;
	}
}
